<template>
  <div class="upload-passport">
    <div class="title">
      {{passport.elec_name}}
      <div class="s-ocr-label">OCR</div>

      <fliggy-select-file-btn
        v-if="!forbidUpload"
        class="m-l-20"
        :order="order"
        :applicant="applicant"
        :material-name="passport.elec_name"
        :max-select-num="1"
        @confirm="onUploadByFliggy"
      ></fliggy-select-file-btn>
    </div>

    <div class="content">
      <div class="upload-box">

        <!-- 上传 -->
        <upload-item class="upload-item" :img-url="passport.upload[0].url" :upload="passport.upload[0]" :forbid="forbidUpload"
          :verify-passed="passport.upload[0].elec_status === consts.ELEC_STATUS.qualified_0"
          :verify-not-pass="passport.upload[0].elec_status === consts.ELEC_STATUS.unqualified_3"
          :is-reupload="isReupload"
          @saveUploadInputId="saveUploadInputId"
          @uploadFile="uploadPassport" @reviewImage="reviewImage"></upload-item>

        <!-- 分割线 -->
        <div v-if="!passport.upload[0].url" class="dashed-line"></div>

        <template v-if="!passport.upload[0].url">
          <!-- 示例 -->
          <sample class="sample-box" :sample-url="sampleUrl" @click.native="reviewImage(sampleUrl, 'sample', passport)"></sample>

          <!-- 注意事项 -->
          <attention class="attention-box" :attention="passport.attention"></attention>
        </template>

        <template v-else>
          <ocr-info
            ref="infoDetail"
            :infoData="passportInfo"
            :type="isPassportForeign ? 'passportForeign' : 'passport'"
            :currentMaterial="passport"
            :applicantId="applicant.order_applicant_id"
            :orderId="order.user_order_id"
            :forbid="forbidUpload"
            :order="order"
            :shouldShowEdit="passport.upload[0].elec_status !== 3 && passport.upload[0].elec_status !== 0"
            @updateOrder="updateOrder">
          </ocr-info>
        </template>
      </div>

      <!-- 资料不完善备注 -->
      <memo class="memo" v-if="passport.upload[0].memo" :memo-content="passport.upload[0].memo"></memo>
    </div>
  </div>
</template>

<script>
import Http from '@/libs/http';
import ocrInfo from '../../components/upload/ocr-info/ocr-info';
import uploadItem from './upload-item.vue';
import attention from './attention.vue';
import memo from './memo.vue';
import sample from './sample.vue';
import uploadFileService from '../../services/upload-file-service';
import uploadService from '../../services/upload-service';
import materialConstants from '../../constants/material-constants';
import applicantConstants from '../../constants/applicant-constants';
import sampleUrl from '../../assets/imgs/upload/passport-sample.png';
import imageService from '../../services/image-service';
import FliggySelectFileBtn from './ota/fliggy-select-file-btn.vue';
import fileService from '../../services/file-service';
import utils from '../../libs/utils';


export default {
  name: 'uploadPassport',
  components: {
    attention,
    uploadItem,
    memo,
    sample,
    ocrInfo,
    FliggySelectFileBtn,
  },
  props: {
    passport: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    applicant: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    isReupload: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      sampleUrl,
      consts: {
        ELEC_STATUS: materialConstants.ELEC_STATUS,
      },
      oringinPassportInfo: {
        passport_country_code: '',
        country_code: '',
        surname_cn: '',
        name_cn: '',
        surname_pinyin: '',
        name_pinyin: '',
        gender: '',
        birthday: '',
        passport_number: '',
        issue_date: '',
        expire_date: '',
        birth_place_cn: '',
        other_birth_place_cn: '',
        birth_place_pinyin: '',
        other_birth_place_pinyin: '',
        issue_place_cn: '',
        other_issue_place_cn: '',
        issue_place_pinyin: '',
        other_issue_place_pinyin: '',
        issue_authority_cn: '',
        issue_authority_en: '',
      },
      passportInfo: {
        passport_country_code: '',
        country_code: '',
        surname_cn: '',
        name_cn: '',
        surname_pinyin: '',
        name_pinyin: '',
        gender: '',
        birthday: '',
        passport_number: '',
        issue_date: '',
        expire_date: '',
        birth_place_cn: '',
        other_birth_place_cn: '',
        birth_place_pinyin: '',
        other_birth_place_pinyin: '',
        issue_place_cn: '',
        other_issue_place_cn: '',
        issue_place_pinyin: '',
        other_issue_place_pinyin: '',
        issue_authority_cn: '',
        issue_authority_en: '',
      },
    };
  },
  computed: {

    // 禁用上传
    forbidUpload() {
      if (this.isReupload) {
        // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
        if (uploadService.isOrderStatusBeforePay(this.order.order_status)) {
          return false;
        }

        const isApplicantVerifyNotPass = this.applicant.applicant_status === applicantConstants.STATUS.verifyNotPassed_2;

        // 申请人不是资料不完善，不能上传
        if (!isApplicantVerifyNotPass) {
          return true;
        }

        // 一项都没有的时候需要禁用上传(出现在用户下单的时候没有上传资料，资料不完善的时候也没有需补充资料，但是此时需要展示，且不能上传)
        const isEmptyUpload = Boolean(!this.passport.upload[0].url);

        // 护照预审合格
        const isPassportVerifyPassed = this.passport.upload[0].elec_status === materialConstants.ELEC_STATUS.qualified_0;

        return isEmptyUpload || isPassportVerifyPassed;
      }
      return false;
    },
    isPassportForeign() {
      return this.passportInfo.passport_country_code && this.passportInfo.passport_country_code !== 'CHN';
    },
  },
  methods: {

    // 上传护照
    uploadPassport(file) {

      // 设置loading状态
      this.$set(this.passport.upload[0], 'loading', true);

      imageService.compressImage(file).then(blob =>
        // 上传
        uploadFileService.uploadOcrMaterial(blob, 'passport'),
      ).then((data) => {
        if (data) {
          this.passport.upload[0] && this.$set(this.passport.upload[0], 'loading', false);
          this.passport.upload[0].url = data.url;
          if (data.cropped_image) {
            delete data.cropped_image;
          }

          this.passportInfo = Object.assign({}, this.oringinPassportInfo, { ...data, isConfirm: this.passport.upload[0].elec_status !== 1 });
          this.uploadPassportInfoStandBy();
          this.$nextTick(() => {
            if (this.$refs.infoDetail) {
              this.$refs.infoDetail.initData();
              this.$refs.infoDetail.saveOtherPlace();
            }
          });
        }
      }).catch((e) => {
        if (e) console.log(e);
        this.passport.upload[0] && this.$set(this.passport.upload[0], 'loading', false);
      });
    },

    // 飞猪资料上传
    async onUploadByFliggy({ key_list }) {
      const key = key_list[0];
      const file = await utils.downloadUrlToFile(fileService.getOssFullUrl(key));

      this.uploadPassport(file);
    },

    // 预览图片
    reviewImage(src) {
      this.$emit('reviewImage', src);
    },
    saveUploadInputId(id) {
      this.$emit('saveUploadInputId', id);
    },
    updateOrder() {
      this.$emit('updateOrder');
    },

    uploadPassportInfoStandBy() {
      const { url } = this.passportInfo;
      Http.post('/applicant_passport_save', {
        order_applicant_id: this.applicant.order_applicant_id,
        url,
        ...this.passportInfo,
        isConfirm: undefined,
      })
        .then(() => {
          this.$emit('updateOrder');
          this.$message({
            message: '上传成功',
            type: 'success',
          });
        }).catch((e) => {
          if (e) console.log(e);
        });
    },

    // 获取护照信息
    getPassprotInfo() {
      Http.post('/applicant_passport_query', {
        order_applicant_id: this.applicant.order_applicant_id,
        user_order_id: this.order.user_order_id,
      })
        .then((data) => {
          this.passportInfo = Object.assign({}, this.passportInfo, { ...data, isConfirm: this.passport.upload[0].elec_status !== 1, url: data.img });
          this.$nextTick(() => {
            if (!this.$refs.infoDetail) return;
            this.$refs.infoDetail.checkValid();
            if (!this.passportInfo.isConfirm) {
              this.$refs.infoDetail.saveOtherPlace();
            }
          });
        }).catch((e) => {
          if (e) console.log(e);
        });
    },
  },
  created() {
    if (this.passport && this.passport.upload && this.passport.upload[0].url) {
      this.getPassprotInfo();
    }
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable';
.upload-passport {
  line-height: 1;
  background-color: #fff;
  .title {
    padding: 30px 30px 20px 30px;
    display: flex;
    align-items: center;
  }
  .content {
    padding: 0 30px 30px 30px;
    .upload-box {
      display: flex;
      .upload-item {
        width: 400px;
        height: 238px;
        margin-right: 30px;
      }
      .dashed-line {
        width: 1px;
        height: 238px;
        background-color: white;
        border-right: 1px dashed @border;
        margin-left: 50px;
        margin-right: 50px;
      }
      .sample-box {
        height: 130px;
      }
      .attention-box {
        margin-left: 30px;
        flex: 1;
      }
    }
    .memo {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-passport.vue